import React from 'react'

const Button = ({ children = "Button Text"}) => {
    return (
        <button className='px-[16px] py-[12px] rounded-[10px] bg-[#F02E49] text-[#FFF] text-[18px]'>
            {children}
        </button>
    )
}

export default Button